import styled from 'styled-components';
import slide6 from 'assets/images/mobile/slide6.jpg';
export { SubtitleMobile } from 'styles/shared';

export const Container = styled.section`
  width: 100%;
  min-height: 100vh;
`;

export const Image = styled.img.attrs({ src: slide6 })`
  width: 100%;
`;

export const Content = styled.div`
  width: 100%;
  padding: 32px 48px;
`;
